export default (id, label) => ({
	id,
	label,
	propName: 'accountName',
	sortBy: 'accountName',
	width: 'minmax(var(--px-200), 1fr)'
});
